/* eslint-disable class-methods-use-this */
import { safeCallback } from '../func_arr';
export var EmptyBackendElementType;
(function (EmptyBackendElementType) {
    EmptyBackendElementType[EmptyBackendElementType["Fragment"] = 0] = "Fragment";
    EmptyBackendElementType[EmptyBackendElementType["Element"] = 1] = "Element";
    EmptyBackendElementType[EmptyBackendElementType["TextNode"] = 2] = "TextNode";
    EmptyBackendElementType[EmptyBackendElementType["Component"] = 3] = "Component";
    EmptyBackendElementType[EmptyBackendElementType["VirtualNode"] = 4] = "VirtualNode";
})(EmptyBackendElementType || (EmptyBackendElementType = {}));
/** An empty backend implementation */
export class EmptyBackendContext {
    constructor() {
        this.mode = 1 /* BackendMode.Shadow */;
        /* @internal */
        this._$styleSheetIdInc = 1;
        /* @internal */
        this._$renderCallbacks = null;
        /* @internal */
        this._$shadowRoot = new EmptyBackendShadowRootContext();
    }
    destroy() {
        // empty
    }
    getWindowWidth() {
        return 1;
    }
    getWindowHeight() {
        return 1;
    }
    getDevicePixelRatio() {
        return 1;
    }
    getTheme() {
        return 'light';
    }
    registerStyleSheetContent(_path, _content) {
        // empty
    }
    appendStyleSheetPath(_path, _styleScope) {
        const id = this._$styleSheetIdInc;
        this._$styleSheetIdInc += 1;
        return id;
    }
    disableStyleSheet(_index) {
        // empty
    }
    render(cb) {
        if (this._$renderCallbacks) {
            this._$renderCallbacks.push(cb);
        }
        else {
            const callbacks = (this._$renderCallbacks = [cb]);
            setTimeout(() => {
                this._$renderCallbacks = null;
                callbacks.forEach((cb) => {
                    safeCallback('Render Callback', cb, this, [null]);
                });
            }, 16);
        }
    }
    getRootNode() {
        return this._$shadowRoot;
    }
    createFragment() {
        return new EmptyBackendElement(0 /* EmptyBackendElementType.Fragment */);
    }
    onEvent(_createEvent, _listener) {
        // empty
    }
}
/** An element for empty backend implementation */
export class EmptyBackendElement {
    constructor(type) {
        if (type === 3 /* EmptyBackendElementType.Component */) {
            this._$shadowRoot = new EmptyBackendShadowRootContext();
        }
        else {
            this._$shadowRoot = null;
        }
    }
    release() {
        // empty
    }
    associateValue(_v) {
        // empty
    }
    getShadowRoot() {
        return this._$shadowRoot || undefined;
    }
    appendChild(_child) {
        // empty
    }
    removeChild(_child, _index) {
        // empty
    }
    insertBefore(_child, _before, _index) {
        // empty
    }
    replaceChild(_child, _oldChild, _index) {
        // empty
    }
    spliceBefore(_before, _deleteCount, _list) {
        // empty
    }
    spliceAppend(_list) {
        // empty
    }
    spliceRemove(_before, _deleteCount) {
        // empty
    }
    setId(_id) {
        // empty
    }
    setSlot(_name) {
        // empty
    }
    setSlotName(_name) {
        // empty
    }
    setSlotElement(_slot) {
        // empty
    }
    setInheritSlots() {
        // empty
    }
    setStyle(_styleText, _styleSegmentIndex) {
        // empty
    }
    addClass(_className) {
        // empty
    }
    removeClass(_className) {
        // empty
    }
    clearClasses() {
        // empty
    }
    setClassAlias(_className, _target) {
        // empty
    }
    setAttribute(_name, _value) {
        // empty
    }
    removeAttribute(_name) {
        // empty
    }
    setDataset(_name, _value) {
        // empty
    }
    setText(_content) {
        // empty
    }
    setListenerStats(_type, _capture, _mutLevel) {
        // empty
    }
    setModelBindingStat(_attributeName, _listener) {
        // empty
    }
}
/** A shadow root for empty backend implementation */
export class EmptyBackendShadowRootContext extends EmptyBackendElement {
    // eslint-disable-next-line no-useless-constructor
    constructor() {
        super(4 /* EmptyBackendElementType.VirtualNode */);
    }
    createElement(_tagName, _stylingName) {
        return new EmptyBackendElement(1 /* EmptyBackendElementType.Element */);
    }
    createTextNode(_content) {
        return new EmptyBackendElement(2 /* EmptyBackendElementType.TextNode */);
    }
    createComponent(_tagName, _external, _virtualHost, _styleScope, _extraStyleScope, _externalClasses, _slotMode, _writeIdToDOM) {
        return new EmptyBackendElement(3 /* EmptyBackendElementType.Component */);
    }
    createVirtualNode(_virtualName) {
        return new EmptyBackendElement(4 /* EmptyBackendElementType.VirtualNode */);
    }
}
//# sourceMappingURL=empty_backend.js.map